module.exports = __webpack_public_path__ + "static/media/logo.1a83aa21.svg";